import React from "react";
import { defineMessages, injectIntl } from 'react-intl';

class LocationMessage extends React.Component {
  constructor(props) {
    super(props);

    this.handleOpenMaps = this.handleOpenMaps.bind(this)
  }

  handleOpenMaps() {
    const url = `https://maps.google.com/?q=${this.props.latitude},${this.props.longitude}`
    window.open(url, '_blank');
  }

  render() {
    return (
      <div
        className="location-message-container"
        onClick={this.handleOpenMaps}
      >
        <img
          className='location-image'
          src={'/img/location-default.png'}
          alt='location-picture.png'
          onError={e => e.target.src = '/img/broken_image.png'}
        />
        <div className='location-title'>Vị trí đã ghim</div>
        <div className='location-body'>{this.props.body}</div>
      </div>
    )
  }
}

export default injectIntl(LocationMessage);